//quick-pick-helper has been done to extract common functionality between quick pick multi mode & raw mode

//Sort all the nested list by position property and return the sorted keys
export const getNestedLookUpObjectKeysByPosition = (menu: object) => {
  let keys = Object.keys(menu || {})
    .map((key) => {
      return {
        key: key,
        position: menu[key].position || 0
      };
    })
    .sort((value1, value2) => {
      if (value1.position < value2.position) {
        return -1;
      }
      if (value1.position > value2.position) {
        return 1;
      }
      return 0;
    })
    .map((x) => x.key);

  return keys;
};

export const onAiMultiWrapperChange = (
  field: string,
  values: (string | object)[],
  onChange: (field: string, value: any, options: any, aiFilled?: boolean) => void
) => {
  const result = Object.fromEntries(
    values.map((val) => {
      if (String.isString(val)) {
        return [val, { description: val }];
      }

      const { value, path } = val as any;
      return [path, { description: value }];
    })
  );

  onChange(field, JSON.stringify(result), undefined, true);
};

//Logic to handle when item is selected from the single select/multi-select
export const onSelectHandler = (key: string, text: string, e: any, props: any) => {
  if (!!e) {
    e.preventDefault();
    e.stopPropagation();
  }

  let { menu, selected, onChange, onNavigate, multiSelect, value } = props;

  let onChangeMultiWrapper = (key, val) => {
    let result = Object.assign({}, value);
    if (typeof value === 'string')
      result = {
        previousStringSelection: value
      };

    if (typeof value === 'string')
      result = {
        previousStringSelection: value
      };
    if (typeof val === 'string')
      val = {
        description: val
      };
    if (!result[key]) result[key] = val;
    else delete result[key];
    onChange(key, result);
  };

  let next = menu[key];
  // condition to auto select leaf node when only a single item
  // if(this.props.autoSelectWhenLast && next != undefined && Object.keys(next).length == 1 && menu[Object.keys(next)[0]] == undefined){
  //   onChangeMultiWrapper(key, next[Object.keys(next)[0]])
  //   return
  // }

  if (typeof next !== 'object') {
    //for multi-select extend the logic to remove/add other value on checking/unchecking checkbox
    let res =
      typeof next !== 'undefined'
        ? menu[key]
        : multiSelect && key === 'other'
          ? 'other'
          : menu[selected][key];
    multiSelect ? onChangeMultiWrapper(key, res) : onChange(key, res);
    return;
  }

  if (Object.keys(next).length < 1) {
    multiSelect
      ? onChangeMultiWrapper(key, menu[selected][key])
      : onChange(key, menu[selected][key]);
    return;
  }

  onNavigate(key);
};
